import React from 'react';
import { useContext, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import logo from '../../assets/images/login-logo.png';
import '../../assets/css/loginpage/LoginPage.css';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import { toast } from 'react-toastify';
import { useAuth } from '../../hooks/useAuth';
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const styles = {
    button: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'start',
        gap: 7,
        backgroundColor: 'grey',
        border: 'none',
        borderRadius: '25px',
        color: 'white',
        fontSize: '16px',
        fontWeight: '500',
        padding: '10px 10px 10px 5px',
        cursor: 'pointer',
        outline: 'none',
        transition: 'background-color 0.3s'
    },
    icon: {
        marginRight: '10px',
        marginLeft: 18
    },
    image: {
        width: '34px',
        height: '34px'
    },
    text: {
        fontSize: '16px'
    }
};
const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [pass, setPass] = useState('');
    const { login } = useAuth();
    const [showPassword, setShowPassword] = useState(false);
    // const [credentials, setCredentials] = useState({
    //     email: undefined,
    //     password: undefined
    // });

    const { loading, dispatch } = useContext(AuthContext);

    const navigate = useNavigate();

    const handleChange = (e) => {
        // setCredentials((prev) => ({ ...prev, [e.target.id]: e.target.value }));
    };

    const handleClick = async (e) => {
        e.preventDefault();
        let obj = {
            email: email,
            password: pass
        };
        new WebApiCalls()
            .getLoggedIn(obj)
            .then((res) => {
                if (res.code && res.code == 200 && res.result == 'success') {
                    if (res.desc === 'Apply Google Log In') {
                        googleLogin();
                        return;
                    }
                    res.user.token = res.token;
                    login(res.user);
                    dispatch({ type: 'LOGIN_SUCCESS', payload: res.user });
                    toast(' Welcome, You are Logged-In!', {
                        position: 'top-right',
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined
                    });
                    //navigate("/")
                } else {
                    toast.error('Login failed...! Please check your given email or password.');
                }
            })
            .catch((err) => {});
        // dispatch({ type: 'LOGIN_START' });

        // const response = await sendRequest(BASE_URL + '/user/login', { payload: credentials });
        // if (response.status === 200) {
        //     const userContext = {
        //         first_name: response.data.user.first_name,
        //         last_name: response.data.user.last_name,
        //         role: response.data.user.role,
        //         token: response.data.token
        //     };
        //     successToast(response.data.desc);
        //     dispatch({ type: 'LOGIN_SUCCESS', payload: userContext });
        //     navigate('/');
        // } else if (response.status === 405) {
        //     errorToast(response.data.desc);
        //     dispatch({ type: 'LOGIN_FAILURE' });
        //     navigate('/verify');
        // } else {
        //     errorToast(response?.data?.desc);
        //     dispatch({ type: 'LOGIN_FAILURE' });
        // }
    };
    const googleLogin = useGoogleLogin({
        onSuccess: async (codeResponse) => {
            const userInfo = await axios.post(`${process.env.REACT_APP_BASE_URL}/oauth/auth/google`, {
                code: codeResponse?.code
            });

            new WebApiCalls().getGoogleLoggedIn({ token: userInfo?.data?.id_token }).then((res) => {
                res.user = res.commuter;
                res.user.token = res.token;
                login(res.user);
                dispatch({ type: 'LOGIN_SUCCESS', payload: res.user });
                toast(' Welcome, You are Logged-In!', {
                    position: 'top-right',
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
            });
        },
        onError: (error) => console.log('Login Failed:', error),
        flow: 'auth-code'
    });

    return (
        <Container fluid>
            <Row>
                <Col className="px-0" lg={6}>
                    <div className="left-login-wrapper text-center">
                        <img src={logo} alt="" className="img-fluid" width={300} />
                    </div>
                </Col>
                <Col lg={6} md={9} sm={12} className="mx-auto">
                    <div className="login_form_container mx-auto">
                        <div className="heading-login mb-3 me-sm-auto text-center text-sm-start">
                            <h3>
                                Welcome to
                                <br />
                                <strong>Transit Rewards</strong>
                            </h3>
                        </div>
                        <Form className="w-100" onSubmit={handleClick}>
                            <Form.Group className="mb-3" controlId="email">
                                <Form.Label>E-mail</Form.Label>
                                <Form.Control
                                    className="login-input shadow-none"
                                    type="email"
                                    placeholder="name@example.com"
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </Form.Group>

                            <Form.Group className="mb-" controlId="password">
                                <Form.Label>Password</Form.Label>
                                <div className="position-relative">
                                    <Form.Control type={showPassword ? 'text' : 'password'} placeholder="Password" onChange={(e) => setPass(e.target.value)} required />
                                    <span
                                        className="position-absolute end-0 top-50 translate-middle-y me-2 cursor-pointer"
                                        onClick={() => setShowPassword(!showPassword)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                    </span>
                                </div>
                            </Form.Group>

                            <div className="d-flex justify-content-between mb-3 mt-2">
                                <div className="remember-check-wrapper">
                                    <input type="checkbox" className="remember-check" defaultChecked="true" />
                                    <Form.Label className="ms-2">Remember me</Form.Label>
                                </div>

                                <Link to={'/forget-password'} className="forgot-pass">
                                    Forgot Password?
                                </Link>
                            </div>
                            <div className="submit-btn-wrapper">
                                <Button type="submit" className="login-btn w-100">
                                    {loading ? 'Loading' : 'Login'}
                                </Button>
                                <button onClick={() => googleLogin()} type="button" style={styles.button} className="w-100 mt-4">
                                    <span style={styles.icon}>
                                        <img src="https://developers.google.com/identity/images/g-logo.png" alt="Google Logo" style={styles.image} />
                                    </span>
                                    <span style={styles.text}>Commuters Google Sign up</span>
                                </button>
                                {/* <span className="text-center text-muted">or</span>
                                <Link to="/signup" className="d-grid text-center text-dark">
                                    <Button className="theme-outline-cancel-btn">SignUp</Button>
                                </Link> */}
                            </div>
                        </Form>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default LoginPage;
